export default "__VITE_ASSET__836d6d7f__"